// extracted by mini-css-extract-plugin
export default {"wrapper":"border-gap_wrapper__Ce4lW","circle":"border-gap_circle__YVvEF","top":"border-gap_top__2yI0f","bottom":"border-gap_bottom__8gU6L"};